<template>
  <div class="content container-fluid">
    <!-- Merchant Selection -->
    <div class="row">
      <div class="col-md-5">
        <div class="form-group">
          <h4>Merchant</h4>
          <select class="form-control" v-model="merchantId" required>
            <option value>-- Select Merchant --</option>
            <option
              v-for="item in merchants"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <!-- Merchant Selection End -->

    <!-- API key -->
    <div class="row mt-4" v-if="this.merchantId != ''">
      <div class="col-md-5">
        <div class="form-group">
          <h4>Merchant's API Key</h4>
          <input readonly type="text" class="form-control" v-model="apiKey" />
        </div>
      </div>
      <div class="col-md-1 pl-0">
        <button class="btn btn-primary" style="margin-top: 32px" @click="reset">
          Reset
        </button>
      </div>
    </div>
    <!-- API key -->

    <!-- Batch Upload Guide -->
    <div class="row mt-3" v-if="this.merchantId != '' && this.allow_batch_ecoupon">
      <div class="col-md-12">
        <div class="section">
          <div class="text-center title">Batch E-Coupon API Guide</div>
          <hr />
          <label class="mb-0">
            Below is the API URL to get coupon code from batch upload. It is a
            POST HTTP request.
          </label>
          <input readonly type="text" class="form-control" v-model="apiUrl" />
          <label class="mb-0 mt-3">
            For authentication, API key must be passed in the request header
          </label>
          <pre class="disabled">
headers: {
    'api-key': '{{ apiKey }}'
}</pre
          >
          <label class="mb-0 mt-3">
            Below parameters are required to be passed in the request body
          </label>
          <table class="table table-bordered mb-0">
            <thead class="thead-light">
              <tr>
                <th>Object</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>type</td>
                <td><b>[Required]</b> Specify 'batch'</td>
              </tr>
              <tr>
                <td>remarks</td>
                <td><b>[Required]</b> Specify any remarks</td>
              </tr>
            </tbody>
          </table>
          <label class="mb-0 mt-3">Example API Request body</label>
          <pre class="disabled">
{
    'type': 'batch',
    'remarks': 'Input your remarks here'
}</pre
          >
          <label class="mb-0 mt-3">
            If API request is successful, it will return the code. Below are
            example of the API response.
          </label>
          <pre class="disabled">
{
    'success': true,
    'code': 'XYZ8312'
}</pre
          >
        </div>
      </div>
    </div>
    <!-- /Batch Upload Guide -->

    <!-- Flexible Guide -->
    <div class="row mt-5" v-if="this.merchantId != '' && this.allow_flexible_ecoupon">
      <div class="col-md-12">
        <div class="section">
          <div class="text-center title">Flexible E-Coupon API Guide</div>
          <hr />
          <label class="mb-0">
            Below is the API URL to get coupon code from batch upload. It is a
            POST HTTP request.
          </label>
          <input readonly type="text" class="form-control" v-model="apiUrl" />
          <label class="mb-0 mt-3">
            For authentication, API key must be passed in the request header
          </label>
          <pre class="disabled">
headers: {
    'api-key': '{{ apiKey }}'
}</pre
          >
          <label class="mb-0 mt-3">
            Below parameters are required to be passed in the request body
          </label>
          <table class="table table-bordered mb-0">
            <thead class="thead-light">
              <tr>
                <th>Object</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>type</td>
                <td><b>[Required]</b> Specify 'flexible'</td>
              </tr>
              <tr>
                <td>remarks</td>
                <td>[Optional] Specify any remarks</td>
              </tr>
            </tbody>
          </table>
          <label class="mb-0 mt-3">Example API Request body</label>
          <pre class="disabled">
{
    'type': 'flexible',
    'remarks': 'Input your remarks here'
}</pre
          >
          <label class="mb-0 mt-3">
            If API request is successful, it will return the code. Below are
            example of the API response.
          </label>
          <pre class="disabled">
{
    'success': true,
    'code': '5OAWMQ8B'
}</pre
          >
        </div>
      </div>
    </div>
    <!-- /Flexible Guide -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      merchantId: '',
      merchants: [],
      apiKey: "",
      apiUrl: (process.env.NODE_ENV === 'production' ? config.API_URL_PRODUCTION : config.API_URL_UAT) + "/getCouponCode",
      allow_batch_ecoupon: false,
      allow_flexible_ecoupon: false
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
  },
  watch: {
    "merchantId": function (val, oldVal) {
      this.getApiKey();

      console.log(process.env.NODE_ENV);
      console.log(process.env);

      this.allow_batch_ecoupon = this.merchants.find(obj => obj.id === val).allow_batch_ecoupon;
      this.allow_flexible_ecoupon = this.merchants.find(obj => obj.id === val).allow_flexible_ecoupon;
    },
  },
  methods: {
    getMerchants() {
      let param = {};
      this.$store.state.isLoading = true;
      API.getAllMerchants(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.merchants = response.data.records;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    getApiKey() {
      if ( this.merchantId && this.merchantId != "" ) {
        let param = {
          merchant_id: this.merchantId,
        };
        this.$store.state.isLoading = true;
        API.getApiKey(param, this.config)
          .then((response) => {
            this.$store.state.isLoading = false;
            if (response.data.success) {
              this.apiKey = response.data.api_key;
            } else {
              this.$swal(response.data.message, { icon: "error" });
            }
          })
          .catch((error) => {
            this.$store.state.isLoading = false;
            console.log(error);
          });
      }
      else {
        this.apiKey = "";
      }
    },
    reset() {
      let param = {
        merchant_id: this.merchantId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to reset your API key?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.resetApiKey(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.apiKey = response.data.api_key;
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
  },
  created() {
    //this.getApiKey();
    this.getMerchants();
  },
};
</script>

<style scoped>
.disabled {
  background-color: #f5f5f5;
  color: #6c757d;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 4px;
  font-family: monospace;
  overflow: auto;
  margin-bottom: 0;
  font-size: 14px;
}

.table th,
.table td {
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 13px;
}

.title {
  font-size: 22px;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/Merchant/ApiDoc.vue